import { render, staticRenderFns } from "./SubscriptionClassForm.vue?vue&type=template&id=6145b3b5"
import script from "./SubscriptionClassForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionClassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports